<template>
  <div class="loading-wrapper" v-show="show">
    <van-loading class="load-one" type="spinner" color="#37357F"/>
  </div>
</template>

<script>

  export default {
    name: "ALloading",
    props: {},
    data() {
      return {
        show: false,
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .loading-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
  }

  .load-one{
    width: 50px;
    height: 50px;
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// app/components/loading/ALloading.vue